import { ICompany } from '@getgreenline/homi-shared'
import { IGlobalProduct } from '@getgreenline/global-products'

export const getSkuFromGlobalProduct = (product: IGlobalProduct, company?: ICompany) => {
  return product.regionalData?.find(
    (regionalData) => regionalData.region === company?.province?.toUpperCase(),
  )?.sku
}

export const getSkuFromGlobalProductV2 = (product: IGlobalProduct): string => {
  return (product?.regionalData?.length && product.regionalData[0].sku) || ''
}
